import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';

import {
  Dialog,
  Button,
} from '@/components/mui/Layouts/components/ApplicationDropdown/components/TalkToUsDialog/StyledComponents';

import { ReactComponent as DCIcon } from '@/components/mui/Layouts/components/ApplicationDropdown/components/TalkToUsDialog/icons/dc-icon.svg';
import BGImage from '@/components/mui/Layouts/components/ApplicationDropdown/components/TalkToUsDialog/icons/dc-bg.png';

const TalkToUsDialog = ({ open, onClose, action, module }) => {
  const { formatMessage } = useIntl();

  if (!module) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <Stack alignItems="center" sx={{ p: 3, maxWidth: 555, width: '100%' }}>
        <Box fontSize={59} display="flex" sx={{ my: 2 }}>
          <SvgIcon component={DCIcon} inheritViewBox fontSize="inherit" />
        </Box>
        <Typography variant="h5" sx={{ my: 1.5 }}>
          {formatMessage({
            id: `app.selector.requestAccessDialog.${module}.title`,
            defaultMessage: `Upgrade to access DOKKA ${module}`,
          })}
        </Typography>
        <Typography variant="subtitle1" textAlign="center" sx={{ my: 1.5 }}>
          {formatMessage({
            id: `app.selector.requestAccessDialog.${module}.body`,
            defaultMessage: ' ',
          })}
        </Typography>
        <Box style={{ margin: '12px 36px' }}>
          <img src={BGImage} alt="AP" width="100%" />
        </Box>
        <Stack direction="row" sx={{ my: 1.5 }} spacing={1}>
          <Button variant="text" onClick={onClose}>
            {formatMessage({
              id: 'app.selector.requestAccessDialog.action.cancel',
              defaultMessage: 'No thanks',
            })}
          </Button>
          <Button sx={{ p: [0.75, 1.75] }} variant="contained" onClick={action}>
            {formatMessage({
              id: 'app.selector.requestAccessDialog.action.sendRequest',
              defaultMessage: 'Talk to us',
            })}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default TalkToUsDialog;
